module.exports = __webpack_public_path__ + "static/media/storeMaster.374e6c1f.svg";